<template>
  <div class="container py-10 mx-auto px-1 sm:px-0">
    <h1 class="text-3xl sm:text-4xl font-bold">Sign Up</h1>
    <p class="mt-3 text-gray-700">
      Create your account to get started.
    </p>

    <form class="mt-6 space-y-4 max-w-md">
      <div>
        <label class="block text-sm font-medium">Email</label>
        <input type="email" class="mt-1 w-full border rounded px-3 py-2" placeholder="you@example.com" />
      </div>
      <div>
        <label class="block text-sm font-medium">Password</label>
        <input type="password" class="mt-1 w-full border rounded px-3 py-2" placeholder="••••••••" />
      </div>
      <div>
        <label class="block text-sm font-medium">Confirm Password</label>
        <input type="password" class="mt-1 w-full border rounded px-3 py-2" placeholder="••••••••" />
      </div>
      <button type="button" class="bg-[#54586a] text-white px-4 py-2 rounded">
        Create Account
      </button>
    </form>
  </div>
</template>

<script setup>
// no script needed yet
</script>
